import { createFileRoute } from '@tanstack/react-router';

import { ConnectLandingPage } from 'src/apps/checkout/app/pages/Connect.Landing';

export const Route = createFileRoute(
  '/_auth/_only-header/store/connect/_allowed/'
)({
  component: () => {
    return <ConnectLandingPage />;
  },
});
